<template>
    <v-container class="pa-0 ma-0" fluid>
      <v-row class="mb-0 pb-0">
        <v-col cols="10" md="6">
            <v-text-field
              label=""
              placeholder="Usuarios...."
              class="caption"
              v-model="fieldSearch"
              @keyup.enter="loadItems"
              filled
              dense
              hide-details
              autocomplete="off"
            >
            </v-text-field>
        </v-col>
        <v-col cols="2" md="6" class="my-2">
          <v-btn  tile medium color="primary" icon @click="loadItems" :loading="loadingSearch">
            <v-icon medium>fa-search</v-icon>
          </v-btn>          
        </v-col>
      </v-row>
			<v-row class="px-0 py-0">
				<v-col cols=12 >
          <v-data-table
            dense
            min-height="200px"
            height="320px"
            class="elevation-2"     
            :headers="headers"
            :items.sync="usuarios"
            :fixed-header="true"
            :loading="loadingSearch"
            :hide-default-footer="false"
            :items-per-page="itemsPerPage"          
            :mobile-breakpoint=600
            :footer-props="{'disable-items-per-page':false, showFirstLastPage: true, 'items-per-page-options':[10, 50, 100],'show-current-page':true}"
          >
            <template v-slot:top>
              <v-toolbar flat dense color="white">
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="mb-2"  @click="newItem()">+</v-btn>
              </v-toolbar>
            </template>

            <template v-slot:item="{item,isMobile,headers} ">
              <DataGridBody :item="item" :headers="headers" :isMobile="isMobile" @edit-item="editItem" @delete-item="deleteItem" />
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-dialog v-if="dialog" v-model="dialog" max-width="960px" min-width="320px"  scrollable persistent >
        <Usuario 
          v-if="dialog"
          :editedIndex="editedIndex"
          :editedItem="editedItem"
          :config="{tUsr:1,title:'Cliente'}"

          @close="dialog=false"
          @reload="loadItems()"
        >
        </Usuario>
      </v-dialog>
      
    </v-container>
</template>
<script>
  import {mapGetters, mapMutations} from 'vuex'

  import xlsx from 'xlsx'

  export default {
    name: 'Clientes',

    components: {
      Usuario : () => import ('@/componentsByM/Usuarios/Usuario'),
      DataGridBody: () => import  ('@/components/DataGridBody_v2')
    },

    data: () => ({

      dialog:false,
      usuario:"",

      headers: [
        { text: 'Nro Cta'   ,align: 'start' ,sortable: true,  value: 'usr', class:"text-truncate", type:"text"},
        { text: 'R.Social'  ,align: 'start' ,sortable: true,  value: 'nombre', class:"text-truncate", type:"text"},

        { text: 'Viajante'  ,align: 'start' ,sortable: true,  value: 'viajante', class:"text-truncate", type:"text"},
        { text: 'Localidad' ,align: 'start' ,sortable: true,  value: 'localidad', class:"text-truncate", type:"text"},
        { text: 'Tipo Usr'  ,align: 'start' ,sortable: true,  value: 'perfil', type:"text",class:"d-none"},
        { text: 'Estado'    ,align: 'center',sortable: false, value: 'estado', type:"checkbox"},
        { text: ''          ,align: 'end'   ,sortable: false, value: 'actions', width:"110px", type:"actions" },
      ],
      items:[],

      page: 1,
      pageCount: 0,
      itemsPerPage: 2,

      editedIndex: -1,
      editedItem:[],

      //INI BUSQUEDA
      loadingSearch:false,
      fieldSearch:"",
      //FIN BUSQUEDA    

    }),
    created: function () {
      //console.log("Componente creado")
      this.initialize()
      //this.openNotif()
    },
    mounted: function () {
      //console.log("Componente mondado")

      
    },
    watch: {
   
    },

    methods: {
      ...mapMutations(['setLogout','setNotif']),
      openNotif (){
        console.log( this.$vuetify )
        this.setNotif({status:true, text:"HOLA MUNDO",color:"error"})
      },

      initialize () {
        this.loadItems()
      },

      exportXLS (){
      },



      newItem() {
        this.editedIndex=-1
        this.editedItem=[]

        this.dialog = true
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem=item
        this.dialog = true
      },

      deleteItem (item) {
        confirm('Seguro que desea eliminar el cliente seleccionado?') && this.deleteCliente(item.id)
      },

      async deleteCliente(id){

        let opt={
          method: 'DELETE', 
          mode: 'cors',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },  
          //body: JSON.stringify(param),
        }
        let response = await fetch(`${this.ROOT_API}cms/usuarios/${id}`, opt)
        
        await this.loadItems()
        
      },

      async loadItems(){

        //console.log("INICIO loadUsuarios")


        this.loadingSearch=true
        this.items=[]

        try{
          let response
          let opt

          opt={
            method: 'GET', 
            mode: 'cors'
          }
          response = await fetch(`${this.ROOT_API}cms/usuarios`, opt)
          if (response && response.ok ) {
             
            this.items=[]= await response.json()
            //console.log("i-->",i)
          }
          else {
            throw("Error al recuperar usuarios")
          }
        }
        catch (err){
          //this.setNotif({status:true, text:err,color:"error"})
          alert(err)
          console.log(err)
        }
        this.loadingSearch=false

      },


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      words: function () {
        
        ////this.texto = this.texto.replace(/[^a-zA-Z0-9\ \ñ\Ñ]/g, ' ')
        return this.fieldSearch.split(' ').filter(x => x.length>2)
      },

      usuarios: function(){
        let r=this.items/*.filter( 
            item => item.razonSoc.toLowerCase().includes(this.usuario.toLowerCase()) ||
                    (item.email && item.email.toLowerCase().includes( this.usuario.toLowerCase())) ||
                    (item.emailAux && item.emailAux.toLowerCase().includes( this.usuario.toLowerCase()) ) ||
                    (item.tusuario && item.tusuario.toLowerCase().includes( this.usuario.toLowerCase()) )  
        )*/
        //console.log(r)
        return r//((r && r.length>0)  ? r.map(function(i) { return parseFloat(i.importe) }).reduce((res, item) => res=res + item) : 0).toFixed(2)
      },
    },
  }
</script>

<style lang="scss">
.v-application--is-ltr .v-data-table--fixed-header .v-data-footer {
     margin-right: 0 !important;
}
</style>

